// extracted by mini-css-extract-plugin
export var banner = "PromotionalBanner-module--banner--b6c1e";
export var container = "PromotionalBanner-module--container--bb137";